//@flow
import { call, put, takeLatest, select, all } from "redux-saga/effects";
import {
  GET_CAMPAIGN_SURVEY_REQUESTING,
  GET_CAMPAIGN_SURVEY_SUCCESS,
  GET_CAMPAIGN_SURVEY_ERROR,
  GET_SURVEY_REQUESTING,
  GET_SURVEY_SUCCESS,
  GET_SURVEY_ERROR,
  SUBMIT_ANSWERS_REQUESTING,
  SUBMIT_ANSWERS_SUCCESS,
  SUBMIT_ANSWERS_ERROR,
  GET_ACTIVE_SURVEY_SUCCESS,
  GET_ACTIVE_SURVEY_ERROR,
  GET_ACTIVE_SURVEY_REQUESTING,
  GET_ONBOARDING_SURVEY_ERROR,
  GET_ONBOARDING_SURVEY_SUCCESS,
  GET_ONBOARDING_SURVEY_REQUESTING,
} from "./constants";
import { fetchApi } from "../api";
import { navigate, reset } from "../navigation/navigatorHelper";
import { showAlert } from "../profileSettings/actions";
import i18n from "../../i18n";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import { SIGNUP_SURVEY_SET_STATS } from "../signup/constants";

const endPoints = {
  submitAnswers: "/v1/surveys/answers",
  getCampaignSurvey: "/v1/surveys/campaign",
  getActiveSurvey: "/v1/surveys/active",
  getSurveyById: "/v1/surveys", // :surveyId
  getMySurvey: "/v1/surveys/my-survey", // :surveyId :userId
  getCampaignOnboardingSurvey: "/v1/surveys/onboarding", // ? campaignId=
};
/*
const getSurveyApi = data => {
  const { surveyId } = data;

  return fetchApi(`${endPoints.getSurveyById}?surveyId=${surveyId}`, {}, "get");
};
*/
const getMySurveyApi = data => {
  const { surveyId, userId } = data;

  return fetchApi(
    `${endPoints.getMySurvey}?surveyId=${surveyId}&userId=${userId}`,
    {},
    "get",
  );
};

const getOnboardingSurveyApi = data => {
  const { accessCode, userId, campaignId } = data;

  return fetchApi(
    `${endPoints.getCampaignOnboardingSurvey}?accessCode=${accessCode}&campaignId=${campaignId}&userId=${userId}`,
    {},
    "get",
  );
};

const getCampaignSurveyApi = data => {
  const { campaignId, userId, surveyId } = data;

  return fetchApi(
    `${endPoints.getCampaignSurvey}?campaignId=${campaignId}&userId=${userId}&surveyId=${surveyId}`,
    {},
    "get",
  );
};

const getActiveSurveyApi = data => {
  const { userId } = data;

  return fetchApi(`${endPoints.getActiveSurvey}?userId=${userId}`, {}, "get");
};

const submitAnswersApi = data => {
  return fetchApi(`${endPoints.submitAnswers}`, data, "post");
};

function* getSurveyFlow(action) {
  try {
    const userId = yield select(getUserId);
    const response = yield call(getMySurveyApi, { ...action.payload, userId });

    yield put({ type: GET_SURVEY_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: GET_SURVEY_ERROR, error: error.message });
  }
}

function* getActiveSurveyFlow(action) {
  try {
    const response = yield call(getActiveSurveyApi, action.payload);

    yield put({ type: GET_ACTIVE_SURVEY_SUCCESS, payload: response });
    navigate("Survey");
  } catch (error) {
    yield put({ type: GET_ACTIVE_SURVEY_ERROR, error: error.message });
  }
}

function* getOnboardingSurveyFlow(action) {
  try {
    const response = yield call(getOnboardingSurveyApi, action.payload);

    yield put({ type: GET_ONBOARDING_SURVEY_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: GET_ONBOARDING_SURVEY_ERROR, error: error.message });
  }
}

function* getCampaignSurveyFlow(action) {
  try {
    const response = yield call(getCampaignSurveyApi, action.payload);

    yield put({ type: GET_CAMPAIGN_SURVEY_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: GET_CAMPAIGN_SURVEY_ERROR, error: error.message });
  }
}

function* submitAnswersFlow(action) {
  try {
    const { isComingFromSignup = false, campaignId } = action.payload;

    const response = yield call(submitAnswersApi, {
      ...action.payload,
      campaignId: campaignId || undefined,
    });

    yield put({ type: SUBMIT_ANSWERS_SUCCESS, payload: response });

    if (isComingFromSignup) {
      yield put({ type: SIGNUP_SURVEY_SET_STATS, payload: action.payload });
      navigate("WeeklyGoal", { isComingFromSignup });
    }

    if (!isComingFromSignup) {
      navigate("Main");

      yield put(
        showAlert({
          title: i18n.t("success-survey-title"),
          message: i18n.t("success-survey-message"),
        }),
      );
    }
  } catch (e) {
    console.log(e);
    yield put({ type: SUBMIT_ANSWERS_ERROR, error: e.message });
  }
}

function* watcher() {
  yield all([
    takeLatest(GET_CAMPAIGN_SURVEY_REQUESTING, getCampaignSurveyFlow),
    takeLatest(SUBMIT_ANSWERS_REQUESTING, submitAnswersFlow),
    takeLatest(GET_ACTIVE_SURVEY_REQUESTING, getActiveSurveyFlow),
    takeLatest(GET_SURVEY_REQUESTING, getSurveyFlow),
    takeLatest(GET_ONBOARDING_SURVEY_REQUESTING, getOnboardingSurveyFlow),
  ]);
}

export default watcher;
